<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Reporting</span>
    <b-container fluid>
      <b-row>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Modules</h5>
          <p>Total: {{ snapshot.data.modules.total }}</p>
          <doughnut :data="graphs.modules"/>
        </b-col>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Components</h5>
          <p>Total: {{ snapshot.data.components.total }}</p>
          <doughnut :data="graphs.components"/>
        </b-col>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Topics</h5>
          <p>Total: {{ snapshot.data.topics.total }}</p>
          <doughnut :data="graphs.topics"/>
        </b-col>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Members</h5>
          <p>Total: {{ snapshot.data.tenant_users.total }}</p>
          <doughnut :data="graphs.members"/>
        </b-col>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Media</h5>
          <p>Total: {{ snapshot.data.media.total }}, Total Size: {{ readableFilesize(snapshot.data.media.total_size) }}</p>
          <doughnut :data="graphs.media"/>
        </b-col>
        <b-col class="text-center mb-5" cols="12" md="6" lg="4" xl="3">
          <h5>Other Reports</h5>
          <div>
            <ul >
              <li>
                <router-link :to="{name: 'admin-reports-knowledgecheck', params: {organization: id}}">
                  Knowledge Checks
                </router-link>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { readableFilesize } from '../../../../helpers'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import doughnut from './doughnut'

export default {
  components: {
    sidebar,
    page,
    doughnut
  },
  data() {
    return { }
  },
  computed: {
    ...mapState('reports', [
      'snapshot'
    ]),
    ...mapGetters('reports', {
      graphs: 'snapshotGraphs'
    }),
    id () {
      return this.$route.params.organization
    }
  },
  mounted () {
    this.$store.dispatch('reports/snapshot')
  },
  methods: {
    readableFilesize
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/reports/index.vue